module.exports = __webpack_public_path__ + "media/images/pc/page_common/reservation_card_dress-d01f04333e18429947b162344fd45c1e.png";